import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/type/feature.types.query.gql"
import type { FeatureTypeQuery } from "@/v2-backoffice-client/feature/type/__types__/feature.types.query"

type Options = QueryHookOptions<FeatureTypeQuery>

/** The kinds a feature can be — a fixed catalog, so this is fetched once and
 * served from the cache everywhere the picker renders. */
export function useFeatureTypeQuery(options?: Options) {
  return useQuery<FeatureTypeQuery>(query, options)
}
